
const baseURL = "https://staging.backend.carchaser.ca/api";

const baseImageUrl = `https://staging.backend.carchaser.ca/uploads/`;
const baseVideoUrl = "https://staging.backend.carchaser.ca/videos/";

export { baseURL, baseImageUrl, baseVideoUrl };
